<template>
  <div class="link_01">
    <div class="equipos-1 avenirnextltpro-medium-big-stone-10px" @click="clickBreadCrumbs">
      Equipos – Seleccionar equipo
    </div>
  </div>
</template>

<script>
export default {
  name: 'Link01',
  methods: {
    clickBreadCrumbs() {
      this.$router.push('/teamsAnalysis/teams');
    },
  },
};
</script>

<style>
.link_01,
.link_01-1,
.link_01-2,
.link_01-3 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 2px 4px;
  position: relative;
  width: fit-content;
}

.equipos-1,
.equipos-2,
.equipos-3,
.equipos-4 {
  letter-spacing: -0.1px;
  line-height: 17px;
  margin-top: -2px;
  position: relative;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: fit-content;
}
.equipos-1:hover {
  color: #23b0ff;
  cursor: pointer;
}
</style>
